<!--
 * @Description: 报警时段
 * @Author: YOYO [792611446@qq.com]
 * @LastEditors: Wang Xiaowu (wangxiaowu@example.com)
 * @Date: 2021-11-22 10:17:45
 * @LastEditTime: 2023-02-11 09:46:06
-->
<template>
<div class="timeEchartsContainer">
  <!-- 报警时段 -->
  <div class="chartItem">
    <div class="itemBox">
      <div class="chartBox">
        <echarts :chart-id="idName" :chart-option="options" v-if="isShow"></echarts>
        <img src="../../assets/img/bigScreen/noData.png" alt="" v-else>
        <!-- <el-empty :image="imgSrc" :image-size="80" v-else></el-empty> -->
      </div>
    </div>
  </div>
</div>
</template>

<script>
import * as echarts from 'echarts'
var dayjs = require('dayjs')
export default {
  props: {
    flag: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      imgSrc: require('../../assets/img/bigScreen/no-data.png'),
      isShow: true,
      options: {
        tooltip: {
          formatter: (a) => {
            return '<div style="color:#fff;">' + '日期：' + a.data[0] + '<br/>' + '<span style="float:left;">' + '时间：' + a.data[1] + '</span>' + '<br/>' + '<span style="float:left">' + '个数：' + a.data[2] + '</span>' + '</div>'
          },
          axisPointer: {
            show: true,
            type: '',
            backgroundColor: 'rgba(29, 55, 82, 0.85)',
            lineStyle: {
              type: 'dashed',
              width: 1
            }
          },
          backgroundColor: 'rgba(29, 55, 82,1)',
          borderWidth: 1,
          borderColor: '#ccc'
        },
        grid: {
          left: '4%',
          right: '10%',
          bottom: '10%',
          top: "15%",
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          splitLine: { show: false },
          axisLine:{
            show: true,
            lineStyle:{ color:'#0477AB' }
          },
          axisLabel: {
            textStyle: { fontSize: 12, color: "#fff" },
            formatter: (a) => a.substr(5)
          },
          axisTick: { show: false },
        },
        yAxis: {
          type: 'value',
          name: '时间',
          nameGap: 5,
          max: 24,
          splitLine: {
            show: true,
            lineStyle: { type: 'dashed', color: '#031F3F' }
          },
          nameTextStyle: { fontSize: 12, color: "#fff" },
          axisLine:{
            lineStyle:{ color:'#fff' }
          },
          axisLabel: {
            textStyle: { fontSize: 12, color: "#fff" },
          },
        },
        series: [{
          data: [],
          type: 'scatter',
          symbolSize: function (data) {
            let size = Math.sqrt(data[2]) * 5
            return size > 30 ? 30 : size
          },
          itemStyle: {
            color: '#4BF3F9'
          }
        }, ],
      }
    }
  },
  computed: {
    idName() {
      return this.flag ? "echartsId1_big" : "echartsId1"
    },
    styleObj() {
      return this.flag ? {
        xyFontSize: 20,
        numSize:20
      } : {
        xyFontSize: 12,
        nameSize:4
      }
    }
  },
  created() {
    // this.initStle()
    this.getEchartsData()
  },
  methods: {
    async getEchartsData() {
      // ['小时'， '日期'， '个数']
      let { code, msg, data } = await this.request.post('/front/alarm/record/getAlarmCountStatisticsByHour?days=7')

      if (code !== 200) {
        if(code == 500){
          this.isShow = false         
          return this.$message.error(msg)
        }
        return
      }
      // console.log(data);
      
      if (data == null|| data.length < 1) {
        // return this.isShow = false
        // 没数据时建造假数据
        let day1 = dayjs().format('YYYY-MM-DD')
        let day2 = dayjs().subtract(1, 'day').format('YYYY-MM-DD')
        let day3 = dayjs().subtract(2, 'day').format('YYYY-MM-DD')
        let day4 = dayjs().subtract(3, 'day').format('YYYY-MM-DD')
        let day5 = dayjs().subtract(4, 'day').format('YYYY-MM-DD')

        data = [
          [0, day1, 0], [0, day2, 0], [0, day3, 0], [0, day4, 0], [0, day5, 0]
        ]
      }
      // let arr = data.map(item=>item[2])
      // let max = Math.max(...arr)
      let result = data.map(([time, date, value]) => [date, time, value])
      this.options.series[0].data = result
      
    },
    initStle() {
      this.options.yAxis.axisLabel.textStyle.fontSize = this.styleObj.xyFontSize
      this.options.yAxis.nameTextStyle.fontSize = this.styleObj.xyFontSize
      this.options.xAxis.axisLabel.textStyle.fontSize = this.styleObj.xyFontSize
      this.options.xAxis.nameTextStyle.fontSize = this.styleObj.xyFontSize
       /* this.options.series[0].symbolSize=function (data) {
            return Math.sqrt(data[2])+4
          } */
    },

  }
}
</script>

<style lang="scss" scoped>
.timeEchartsContainer {
  font-size: 0;
  text-align: center;
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: url('../../assets/img/bigScreen/card-box.png') no-repeat;
  background-size: 100% 100%;  

  .chartItem {
    width: 100%;
    height: 100%;

    .itemBox {
      width: 100%;
      height: 100%;

      .chartBox {
        width: 100%;
        height: 100%;
        >img {
          width: 90%;
          height: 90%;
          margin-top: 5%;
        }
        // background: rgba(29, 55, 82, 0.85);
      }
    }
  }
}
</style>
